import AdminGuard from '@/auth/guard/admin-guard';
import { TeamListPage, TeamEditPage, TeamCreatePage } from './imports';

export const teamRoutes = [
  {
    path: 'teams',
    children: [
      {
        element: (
          <AdminGuard hasContent>
            <TeamListPage />
          </AdminGuard>
        ),
        index: true,
      },
      {
        path: 'list',
        element: (
          <AdminGuard hasContent>
            <TeamListPage />
          </AdminGuard>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <AdminGuard hasContent>
            <TeamEditPage />
          </AdminGuard>
        ),
      },
      {
        path: 'new',
        element: (
          <AdminGuard hasContent>
            <TeamCreatePage />
          </AdminGuard>
        ),
      },
    ],
  },
];
